@let values = dimensions();

@if (!editing()) {
  <div class="detail-row">
    <span class="detail-label">Outer Diameter (OD)</span>
    <span class="detail-value mono">{{ values?.dod ?? "--" }}<span class="detail-unit"> in</span></span>
  </div>
  <div class="detail-row">
    <span class="detail-label">Inner Diameter (ID)</span>
    <span class="detail-value mono">{{ values?.did ?? "--" }}<span class="detail-unit"> in</span></span>
  </div>
  <div class="detail-row">
    <span class="detail-label">Drift</span>
    <span class="detail-value mono">{{ values?.drift ?? "--" }}<span class="detail-unit"> in</span></span>
  </div>
  <div class="detail-row">
    <span class="detail-label">Weight</span>
    <span class="detail-value mono">{{ values?.tareWeight ?? "--" }}<span class="detail-unit"> lbs</span></span>
  </div>
  <div class="detail-row">
    <span class="detail-label">Working Length</span>
    <span class="detail-value mono">{{ values?.workingLength ?? "--" }}<span class="detail-unit"> in</span></span>
  </div>
  <div class="detail-row">
    <span class="detail-label">Overall Length</span>
    <span class="detail-value mono">{{ values?.overallLength ?? "--" }}<span class="detail-unit"> in</span></span>
  </div>
  <div class="detail-row">
    <span class="detail-label">Open Length</span>
    <span class="detail-value mono">{{ values?.lengthOpen ?? "--" }}<span class="detail-unit"> in</span></span>
  </div>
  <div class="detail-row">
    <span class="detail-label">Closed Length</span>
    <span class="detail-value mono">{{ values?.lengthClosed ?? "--" }}<span class="detail-unit"> in</span></span>
  </div>
} @else if (form(); as dimensionsForm) {
  <mat-form-field>
    <mat-label>Outer Diameter (OD)</mat-label>
    <input matInput type="number" [formField]="dimensionsForm.dod" />
    <span matTextSuffix>in</span>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Inner Diameter (ID)</mat-label>
    <input matInput type="number" [formField]="dimensionsForm.did" />
    <span matTextSuffix>in</span>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Drift</mat-label>
    <input matInput type="number" [formField]="dimensionsForm.drift" />
    <span matTextSuffix>in</span>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Weight</mat-label>
    <input matInput type="number" [formField]="dimensionsForm.tareWeight" />
    <span matTextSuffix>lbs</span>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Working Length</mat-label>
    <input matInput type="number" [formField]="dimensionsForm.workingLength" />
    <span matTextSuffix>in</span>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Overall Length</mat-label>
    <input matInput type="number" [formField]="dimensionsForm.overallLength" />
    <span matTextSuffix>in</span>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Open Length</mat-label>
    <input matInput type="number" [formField]="dimensionsForm.lengthOpen" />
    <span matTextSuffix>in</span>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Closed Length</mat-label>
    <input matInput type="number" [formField]="dimensionsForm.lengthClosed" />
    <span matTextSuffix>in</span>
  </mat-form-field>
}
